// Actions
export const LIST_PHARM_FETCH  = '[ListPharm] Fetch'

// Mutations
export const LIST_PHARM_META   = '[ListPharm] meta'
export const LIST_PHARM_OBTAIN = '[ListPharm] obtain'
export const LIST_PHARM_CLEAR  = '[ListPharm] clear'
export const LIST_PHARM_SET_LOADING = '[ListPharm] set loading'
